import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: /*@__PURE__*/_normalizeClass({
            wrapper: true,
            enabled: true
        })
}
const _hoisted_2 = { class: "text-white pr-1 pl-1" }

import {__} from "~/ts/library/Translate";
import useTextareaComponent, {} from "~/operatorApplication/vue/dialogs/dialog/textarea/useTextareaComponent";
import {computed, ref} from "vue";
import getCopilotsBySite from "~/operatorApplication/ts/service/copilot/getCopilotsBySite";
import {
    getCopilotAuthByClient,
    toggleCopilotSuggests
} from "~/operatorApplication/ts/service/copilot/toggleCopilotSuggests";
import CopilotPopover from "~/operatorApplication/vue/dialogs/dialog/textarea/buttons/CopilotPopover.vue";
import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";



import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "CopilotSuggestButton"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

let {client, site} = useTextareaComponent();

let copilots = computed(() => {
    return getCopilotsBySite(site.value);
});

let isCopilotEnabled = computed({
    get() {
        return !!client.value.copilot.enabled && copilots.value.length > 0;
    },
    set(value: boolean) {
        setTimeout(() => {
            toggleCopilotSuggests(client.value, value);
        }, 10);
    }
});

let popoverModel = ref(false);


let selectedAuth = computed(() => {
    return getCopilotAuthByClient(client.value, site.value);
});

async function selectAuth(auth: OperatorApplicationApi.OperatorGetParamsIntegrationAuthOpenApiModel) {
    popoverModel.value = false;
    toggleCopilotSuggests(client.value, !!auth, auth);
}

/*
watch(isCopilotEnabled, async value => {
    if (value) {
        if (!client.value.languageIsoCode) {
            let p: OperatorApplicationApi.OperatorCopilotDetectClientLanguageOpenApiModel = {
                username: client.value.username
            };
            let result = await (new OperatorApiRequest({
                url: "/copilot/detectClientLanguage",
                p,
                silent: true
            })).send();
            if (result.showMessageOnError()) {
                isCopilotEnabled.value = false;
            }
        }
    }
})*/

return (_ctx: any,_cache: any) => {
  const _directive_my_tooltip = _resolveDirective("my-tooltip")!

  return (_unref(copilots).length > 0 && _unref(isCopilotEnabled) && _unref(site))
    ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_1, [
        _createVNode(CopilotPopover, {
          modelValue: _unref(popoverModel),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(popoverModel) ? (popoverModel).value = $event : popoverModel = $event)),
          site: _unref(site),
          client: _unref(client),
          onSelect: selectAuth
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_2, [
              (_unref(client).copilot.isWorkInProgress)
                ? (_openBlock(), _createBlock(FontAwesomeIcon, {
                    key: 0,
                    icon: "circle-notch",
                    light: "",
                    class: "fa-spin lh-1",
                    style: {"height":"0.9em"}
                  }))
                : (_openBlock(), _createBlock(FontAwesomeIcon, {
                    key: 1,
                    icon: "sparkles",
                    class: "lh-1",
                    style: {"height":"1em"}
                  }))
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "site", "client"])
      ])), [
        [_directive_my_tooltip, _unref(client).copilot.isWorkInProgress ? _unref(__)('Бот готовит подсказку') : (_unref(selectedAuth) ? _unref(__)(`Подсказки от: %s`,_unref(selectedAuth).descr) : _unref(__)(`Подсказки включены`))]
      ])
    : _createCommentVNode("", true)
}
}

})